import React, { useEffect, useState } from "react";
// import CustomButton from "../../../components/CustomButton/CustomButton";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
// const MyWalletsLogo = `${process.env.PUBLIC_URL}/${val.theme}/MyWallets.png`;
import { makeStyles } from "@mui/styles";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import {
	resetGetManualDepositList,
	getManualDepositList
} from "../../redux/actions/getManualDepositList";
// import Autocomplete, {
// 	createFilterOptions
// } from "@mui/material/lab/Autocomplete";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
import {
	resetAddManualAmountDetails,
	getAddManualAmountDetails
} from "../../redux/actions/addManualAmount";

import {
	resetCustomerWalletCurrencyList,
	getCustomerWalletCurrencyList
} from "../../redux/actions/getCustomerWalletCurrencyList";
import {

	getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import { getUserNameContactSuggestionList } from "../../redux/actions/partnerGetUserNameContactSuggestionAction"

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function ManualDeposit() {
	const [open, setOpen] = React.useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [manualDepositeList, setManualDepositeList] = useState([]);
	const [addmManualDeposite, setaddmManualDeposite] = useState([]);
	const [customerWalletCurrencyArray, setCustomerWalletCurrencyArray] =
		useState([]);

	const [manualDepositeStatus, setManualDepositeListStatus] = useState(false);
	const [addManualDepositeStatus, setAddManualDepositeStatus] = useState(false);
	const [customerWalletCurrencyStatus, setCustomerWalletCurrencyStatus] =
		useState(false);

	const [customerid, setCustomerid] = useState("");
	const [customername, setCustomername] = useState("");
	const [email, setEmail] = useState("");
	const [mobileno, setMobileno] = useState("");

	const [cusid, setCusid] = useState("");
	const [cusname, setCusname] = useState("");
	const [emailId, setEmailId] = useState("");
	const [mobile, setMobile] = useState("");
	const [amount, setAmount] = useState("");
	const [currencyIs, setCurrency] = useState("");
	const [manualDepositIdentifier, setManualDepositIdentifier] = useState("");

	const classes = useStyles();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);
	const getUsernameSuggestionRes = useSelector(
		({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
	)
	const getUsernameContactSuggestionRes = useSelector(
		({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
	)
	const [rowsPerPage, setRowsPerPage] = useState(5);

	const [page, setPage] = useState(0);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "email") {
			setEmail(value);
			// Util.verifyEmail(value) ? setEmail(value) : setEmail(email);
		}
		if (name === "mobileno") {
			setMobileno(value);
			// Util.verifyMobile(value) ? setMobileno(value) : setMobileno(mobileno);
		}

		if (name === "customerid") {
			setCustomerid(value);
			// Util.verifyNumber(value)
			// 	? setCustomerid(value)
			// 	: setCustomerid(customerid);
		}
		if (name === "customername") {
			// setCustomername(value);
			Util.verifyAlphabet(value)
				? setCustomername(value)
				: setCustomername(customername);
		}

		if (name === "currency") {
			setCurrency(value);
		}

		if (name === "amount") {
			if (value === "" || (Number(value) > 0 && /^\d*\.?\d*$/.test(value))) {
				setAmount(value);
			}
		}

		if (name === "manualDepositIdentifier") {
			setManualDepositIdentifier(value);
		}
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const dispatch = useDispatch();
	// useEffect(() => {
	//   const getManualDepositListReq = {
	//     loginDetails: {
	//       walletOwnerId: "1",
	//     },
	//     customerMasterDetailsRequestVO: {
	//       customerId: customerid,
	//       customerName: customername,
	//       customerEmail: email,
	//       mobile: mobileno,
	//     },
	//   };

	//   return dispatch(getManualDepositList(getManualDepositListReq, authToken));
	// }, []);

	const manualDepositeRequest = () => {
		setIsLoading(true);
		setManualDepositeListStatus(true);
		const getManualDepositListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			customerMasterDetailsRequestVO: {
				customerId: customerid.split("-")[0] || "",
				customerName: customername,
				customerEmail: email,
				mobile: mobileno.split("-")[0].substring(1),
			}
		};

		return dispatch(getManualDepositList(getManualDepositListReq, authToken));
	};

	// useEffect(() => {
	//   manualDepositeRequest();
	// }, [])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			manualDepositeRequest();
		}
	}, [regenerateTokenRes.data.status]);

	const getManualDepositListRes = useSelector(
		({ getManualDepositList }) => getManualDepositList
	);

	// console.log(getManualDepositListRes);

	useEffect(() => {
		if (manualDepositeStatus) {
			if (getManualDepositListRes.data.status == "Success") {
				setIsLoading(false);
				setManualDepositeList(
					[].concat(
						getManualDepositListRes.data.customerMasterDetailsRequestVOList
					)
				);
			}
			if (getManualDepositListRes.data.status == "Failed") {
				NotificationPopups("error", "Failed", getManualDepositListRes.data.description)
				setIsLoading(false);
				setManualDepositeList(getManualDepositListRes.data);
			}
			if (getManualDepositListRes.data.status == "Not Found" ||
				getManualDepositListRes.data.status == "NOT FOUND") {
				NotificationPopups("error", "Failed", getManualDepositListRes.data.description)
			}
		}
	}, [getManualDepositListRes.data.status]);

	useEffect(() => {
		if (getManualDepositListRes.data.status == "Success") {
			setPage(0);
		}
	}, [getManualDepositListRes.data.status]);

	const handleClickOpen = (customerId, customerName, mobile, customerEmail) => {
		setCusid(customerId);
		setCusname(customerName);
		setEmailId(customerEmail);
		setMobile(mobile);
		setOpen(true);
		getCustomerWalletCurrency(customerId);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		setCusid("");
		setCusname("");
		setEmailId("");
		setMobile("");
		setAmount("");
		setManualDepositIdentifier("")
		setCurrency("Select Currency");
		getCustomerWalletCurrency("");
	};

	const getCustomerWalletCurrency = (customerId) => {
		setCustomerWalletCurrencyStatus(true);
		const customerWalletCurrencyListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				custmerId: customerId
			}
		};

		return dispatch(
			getCustomerWalletCurrencyList(customerWalletCurrencyListReq, authToken)
		);
	};

	//getCustomerWalletCurrencyList

	const customerWalletCurrencyListRes = useSelector(
		({ getCustomerWalletCurrencyList }) => getCustomerWalletCurrencyList
	);

	const addManualAmount = () => {
		// if (currencyIs == "" && amount == "" && manualDepositIdentifier == "") {
		//   setNotificationOpen(true);
		// } else {
		setAddManualDepositeStatus(true);

		const addManualDepositReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			customerMasterDetailsRequestVO: {
				customerId: cusid,
				customerName: cusname,
				customerEmail: emailId,
				mobile: mobile,
				currency: currencyIs == "Select Currency" ? "" : currencyIs,
				amount: amount ? amount : "",
				bankCode: manualDepositIdentifier
			}
		};

		return dispatch(getAddManualAmountDetails(addManualDepositReq, authToken));
		// }
	};

	const addManualAmountRes = useSelector(
		({ addManualAmount }) => addManualAmount
	);

	//customerWalletCurrencyListRes
	useEffect(() => {
		if (customerWalletCurrencyStatus) {
			if (customerWalletCurrencyListRes.data.status == "success") {
				setCustomerWalletCurrencyArray(customerWalletCurrencyListRes.data);
			}
			if (customerWalletCurrencyListRes.data.status == "Failed") {
				setCustomerWalletCurrencyArray(customerWalletCurrencyListRes);
			}
		}
	}, [customerWalletCurrencyListRes.data.status]);

	useEffect(() => {
		if (addManualDepositeStatus) {
			if (addManualAmountRes.data.status == "success") {
				manualDepositeRequest();
				setOpen(false);
				setNotificationOpen(true);
				setaddmManualDeposite(addManualAmountRes);
				setManualDepositIdentifier("")
				setAmount("");


			}
			if (addManualAmountRes.data.status == "Failed") {
				setOpen(false);
				setNotificationOpen(true);
				setaddmManualDeposite(addManualAmountRes);
				setManualDepositIdentifier("")
				setAmount("");

			}
			if (addManualAmountRes.data.status == "failed") {
				setOpen(false);
				setNotificationOpen(true);
				setaddmManualDeposite(addManualAmountRes);
				setManualDepositIdentifier("")
				setAmount("");

			}
		}
	}, [addManualAmountRes.data.status]);


	useEffect(() => {
		if (getCustomerIdAndNameListRes.data.status === "success") {
			// console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
		}
	}, [getCustomerIdAndNameListRes.data.status])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);


	const filterOptionsL = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}

	//name autocomplete
	useEffect(() => {
		if (getUsernameSuggestionRes.data.status === "success") {
			// console.log("lissttt", getUsernameSuggestionRes.data.list)
		}
	}, [getUsernameSuggestionRes.data.status])


	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getUserContactReq = {
				actionCustomerMasterRequestVO: {
					customerMobileOrName: "",
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				}
			}
			dispatch(getUserNameContactSuggestionList(getUserContactReq, authToken))
			// console.log("userContact", getUserContactReq)
		}
	}, [regenerateTokenRes.data.status])

	const filterOptionsN = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filteredOptionsNames = options.filter(
			(option) =>

				option.customerMobileOrName && option.customerMobileOrName.includes(inputValue)
		);

		return filteredOptionsNames.slice(0, 20);
	}

	//contact autocomplete
	useEffect(() => {
		if (getUsernameContactSuggestionRes.data.status === "success") {
			// console.log("lissttt", getUsernameContactSuggestionRes.data.list)
		}
	}, [getUsernameContactSuggestionRes.data.status])

	const filterOptions = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filteredOptions = options.filter(
			(option) =>
				option.mobile && option.mobile.includes(inputValue) ||
				option.customerMobileOrName.includes(inputValue)
		);

		return filteredOptions.slice(0, 20);
	}
	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "20px", marginTop: "1rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getCustomerIdAndNameListRes.data.currencyList || [""]
								)}
								getOptionLabel={(option) => option}
								filterOptions={filterOptionsL}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Customer ID"
										style={{ marginTop: "3px" }}
										// required
										type="tel"
										fullWidth
										{...params}
										value={customerid}
										name="customerid"
										onBlur={handleChange}
										variant="standard"
										sx={{
											"& .MuiInput-underline:before": {
												borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
												borderBottomColor: "gray", // White color after focus
											},
										}}
									/>
								)}
							/>
						</Grid>
						{/* <Grid item xs={12} sm={12} md={3} lg={3}>
				
							<TextField
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Customer ID"
								// variant="outlined"
								fullWidth={true}
								name="customerid"
								value={customerid || ""}
								onChange={handleChange}
							/>
						</Grid> */}
						{/* <Grid item xs={12} sm={12} md={3} lg={3}>
				
							<TextField
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Customer Name"
								name="customername"
								value={customername || ""}
								onChange={handleChange}
								fullWidth={true}
							/>
						</Grid> */}
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getUsernameSuggestionRes.data.list || [""]
								)}
								getOptionLabel={(option) => option.customerMobileOrName}
								filterOptions={filterOptionsN}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Customer Name"
										style={{ marginTop: "3px" }}
										type="text"
										fullWidth
										{...params}
										value={customername || ""}
										name="customername"
										onBlur={handleChange}
										variant="standard"
										InputProps={{
											sx: {
												"&:before": { borderBottomColor: "gray" }, // before focus
												"&:after": { borderBottomColor: "gray" },  // after focus
											},
										}}
										InputLabelProps={{
											sx: { color: 'gray' }, // Optional: if you want the label to be white
										}}

									/>
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							{/* <Typography variant="body1" align="justify" gutterBottom={true}>
                Email Id
              </Typography> */}
							<TextField
								size="small"
								color="primary"
								autoFocus={true}
								style={{ marginTop: "3px" }}
								type="email"
								label="Email Id"
								name="email"
								value={email || ""}
								onChange={handleChange}
								//variant="outlined"
								fullWidth={true}
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}

							/>
						</Grid>
						{/* <Grid item xs={12} sm={12} md={3} lg={3}>
		
							<TextField
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Mobile No"
								name="mobileno"
								value={mobileno || ""}
								onChange={handleChange}
								//variant="outlined"
								fullWidth={true}
							/>
						</Grid> */}
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getUsernameContactSuggestionRes.data.list || [""]
								)}
								getOptionLabel={(option) => "+" + option.countryCode + " " + option.mobile + "-" + option.customerMobileOrName}
								filterOptions={filterOptions}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Mobile No"
										style={{ marginTop: "3px" }}
										type="text"
										fullWidth
										{...params}
										value={mobileno || ""}
										name="mobileno"
										onBlur={handleChange}
										variant="standard"
										InputProps={{
											sx: {
												"&:before": { borderBottomColor: "gray" }, // before focus
												"&:after": { borderBottomColor: "gray" },  // after focus
											},
										}}
										InputLabelProps={{
											sx: { color: 'gray' }, // Optional: if you want the label to be white
										}}

									/>
								)}
							/>
						</Grid>
					</Grid>

					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={5}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={manualDepositeRequest}
							>
								Search <SearchIcon />
							</CustomButton>

							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                className="riskRuleButton"
                onClick={manualDepositeRequest}
              >
                Search
              </Button> */}
						</Grid>
						<Grid item md={7}></Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : manualDepositeList.length == undefined ||
					manualDepositeList.status == "Failed" ||
					manualDepositeStatus == false ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Id{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Email
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Mobile
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{manualDepositeList &&
											[]
												.concat(manualDepositeList)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row) => (
													<TableRow key={row.customerId}>
														<TableCell
															align="center"
															component="th"
															scope="row"
														>
															{row.customerId}
														</TableCell>
														<TableCell align="center">
															{row.customerName}
														</TableCell>
														<TableCell align="center">
															{row.customerEmail}
														</TableCell>
														<TableCell align="center">{row.mobile}</TableCell>
														<TableCell align="center">
															<CustomButton
																onClick={() =>
																	handleClickOpen(
																		row.customerId,
																		row.customerName,
																		row.mobile,
																		row.customerEmail
																	)
																}
															>
																Add Amount
															</CustomButton>
														</TableCell>
														{/* <TableCell align="center">{row.isActive}</TableCell> */}
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={manualDepositeList.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>

			<div className="">
				<Dialog open={open} onClose={handleClose} className="">
					<DialogTitle>Add Balance</DialogTitle>
					<DialogContent>
						<TextField
							disabled
							autoFocus
							margin="dense"
							id="name"
							label="Customer ID"
							type="name"
							fullWidth
							variant="standard"
							value={cusid || ""}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}



						/>
						<TextField
							disabled
							autoFocus
							margin="dense"
							id="name"
							label="Customer Name"
							type="name"
							fullWidth
							variant="standard"
							value={cusname || ""}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						/>
						<TextField
							disabled
							autoFocus
							margin="dense"
							id="name"
							label="Email Address"
							type="email"
							fullWidth
							variant="standard"
							value={emailId || ""}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}


						/>
						<TextField
							disabled
							autoFocus
							margin="dense"
							id="name"
							label="Mobile"
							type="number"
							fullWidth
							variant="standard"
							value={mobile || ""}
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}
						/>
						<TextField
							required
							autoFocus
							margin="dense"
							label="Amount"
							type="number"
							name="amount"
							fullWidth
							value={amount || ""}
							onChange={handleChange}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						/>

						<TextField
							required
							defaultValue={"Select Currency" || currencyIs}
							size="small"
							color="primary"
							autoFocus={true}
							type="text"
							label="Select Currency"
							// value={currencyIs}
							name="currency"
							fullWidth={true}
							select
							onChange={handleChange}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						>
							<MenuItem value="Select Currency" selected="Select Currency">
								Select Currency
							</MenuItem>
							{(() => {
								if (customerWalletCurrencyArray.currencyList) {
									if (!customerWalletCurrencyArray.currencyList) {
										return <MenuItem>No currencies</MenuItem>;
									}
									return []
										.concat(customerWalletCurrencyArray.currencyList)
										.map((c) => (
											<MenuItem value={c} key={c}>
												{c}
											</MenuItem>
										));
								} else {
									return <MenuItem>No currencies</MenuItem>;
									// return <MenuItem>{t("Something went wrong")}</MenuItem>;
								}
							})()}
						</TextField>

						<TextField
							// required
							autoFocus
							margin="dense"
							label="Manual Deposit Identifier"
							type="text"
							name="manualDepositIdentifier"
							fullWidth
							value={manualDepositIdentifier}
							onChange={handleChange}
							variant="standard"
							InputProps={{
								sx: {
									"&:before": { borderBottomColor: "gray" }, // before focus
									"&:after": { borderBottomColor: "gray" },  // after focus
								},
							}}
							InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							}}

						/>
					</DialogContent>
					<DialogActions>
						<CustomButton style={{ padding: "8px" }} onClick={handleClose}>
							Cancel
						</CustomButton>
						{/* <Button
              style={{
                backgroundColor: "#fff",
                color: "#000",
              }}
              variant="contained"
              onClick={handleClose}
            >
              Cancel
            </Button> */}
						{/* <Button onClick={handleClose}>Add</Button> */}
						{/* <Button
              style={{
                backgroundColor: "#00b9f5",
                color: "white",
              }}
              variant="contained"
              onClick={addManualAmount}
            >
              Add
            </Button> */}
						<CustomButton style={{ padding: "8px" }} onClick={addManualAmount}>
							Add
						</CustomButton>
					</DialogActions>
				</Dialog>
			</div>

			{/* {notificationOpen == true && (
        <div>
          <Dialog open={notificationOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={failed} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
              >
                Please Enter Mandatory Fields
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )} */}

			{/* {addmManualDeposite.data && (
        <div>
          <Dialog open={notificationOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={success} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
              >
                {addmManualDeposite.data.description}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )} */}

			{addManualAmountRes.data.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}

						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addManualAmountRes.data.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addManualAmountRes.data.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}

						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addManualAmountRes.data.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addManualAmountRes.data.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}

						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addManualAmountRes.data.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default ManualDeposit;
